<template>
    <v-row justify="center">
      <v-dialog v-model="dialog.show" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Alert Message</v-card-title>
          <v-card-text>{{ dialog.errMsg }}</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="green darken-1" text @click="$emit('close')"
              >ตกลง</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>
<script>
export default {
  props: {
    dialog: Object
  },
};
</script>
<style scoped>
</style>